import './style.css';
import { jsxs as p, jsx as t } from "react/jsx-runtime";
import { c as _ } from "../../__shared__/index.js";
const c = "_wrapper_1gw6l_1", d = "_text_1gw6l_12", n = "_primary_1gw6l_19", i = "_secondary_1gw6l_26", r = {
  wrapper: c,
  text: d,
  primary: n,
  secondary: i,
  default: "_default_1gw6l_33"
}, f = {
  primary: r.primary,
  secondary: r.secondary,
  default: r.default
};
function m({ text: s, variant: l = "default", Icon: a, iconAdornment: e = "left" }) {
  return /* @__PURE__ */ p("div", { className: _(
    r.wrapper,
    f[l] ?? r.default
  ), children: [
    a && e === "left" && /* @__PURE__ */ t(a, {}),
    /* @__PURE__ */ t("span", { className: r.text, children: s }),
    a && e === "right" && /* @__PURE__ */ t(a, {})
  ] });
}
export {
  m as default
};
//# sourceMappingURL=SavingTag.js.map
